import React from 'react'
import { NavLink } from 'react-router-dom'
import Routes from './../pages/_routes'

import Social from './social'

const Footer = () => (
	<footer>
		<div className="container">
			<h3>Downingtown East Theatre</h3>
			<nav>
				{Routes.Footer.map( (route, index) => {
					return <NavLink activeClassName="active" key={index} to={route.path}>{route.label}</NavLink>
				})}
				<a href="https://app.arts-people.com/index.php?donation=dehs" target="_blank" rel="noopener noreferrer">Make a Donation!</a>
			</nav>
			<Social />
		</div>
	</footer>
)

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js